import type { Move } from '../../../schemas/move';
import { rangerArchetypeMoves } from './archetypes';
import { rangerInitialMoves, rangerStartingAutoMoves, rangerStartingChoiceMoves } from './initial';
import { rangerAdvanced2to5Moves } from './advanced-2-5';
import { rangerAdvanced6to10Moves } from './advanced-6-10';

export {
  rangerArchetypeMoves,
  rangerInitialMoves,
  rangerStartingAutoMoves,
  rangerStartingChoiceMoves,
  rangerAdvanced2to5Moves,
  rangerAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Ranger (manuale V1, sezione "Il
 * Ranger", rr. 5130-5441).
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 3 mosse iniziali automatiche + 2 mosse iniziali di scelta (`starting`,
 *    `pickCount: 1` sul gruppo di scelta — *Marchio del Cacciatore* /
 *    *Compagno Animale*)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 40 mosse.
 *
 * **Pattern stress-testati**:
 *  - **`MoveSchema.replaces`** terzo uso strutturale: *Grampasso*
 *    sostituisce *Ramingo* (entrambe sulla mossa "viaggio pericoloso").
 *  - **Catene L2-5 → L6-10**: 3 catene di prerequisiti (*Seguire Tracce*
 *    → *Perspicace*; *Preda Familiare* → *La Preda del Cacciatore*;
 *    *Bersaglio Facile* → *Tiro Perfetto*).
 *  - **FI-8 stub**: *Compagno Animale* + *Vecchi Amici* + *Riserva di
 *    Caccia* + 4 mosse advanced che richiedono il Compagno (*Ben
 *    Addestrato*, *Il Miglior Amico dell'Uomo*, *Alleato Innaturale*,
 *    *Abilità Speciale*) sono description-only. Le 4 advanced hanno
 *    `prerequisites: ['ranger.compagno-animale']` strutturato per
 *    facilitare il refactor unificato post-12 classi.
 *  - **Mosse multiclasse**: *Abilità Secondarie* e *Addestramento
 *    Avanzato* scelgono da Barbaro/Druido/Guerriero/Ladro/Sciamano
 *    (description-only, FI-17).
 */
export const rangerMoves: readonly Move[] = [
  ...rangerArchetypeMoves,
  ...rangerInitialMoves,
  ...rangerAdvanced2to5Moves,
  ...rangerAdvanced6to10Moves,
];
